import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface WorkQueueCounts {
	order_intake: number;
	order_intake_sources?: {
		online_order: number;
		hl7_discharge_order: number;
	};
	inbound_communication: {
		pst_note: number;
		online_note: number;
	};
	data_management: number;
}

@Injectable({ providedIn: 'root' })
export class WorkQueueCountsService {
	private baseUrl = environment.apiUrl;

	constructor(private http: HttpClient) {}

	getCounts(): Observable<WorkQueueCounts> {
		return this.http.get<WorkQueueCounts>(`${this.baseUrl}work-queue-counts`);
	}
}
